var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.059,39.74L50,37.262v-2.133c1.849-1.816,3-4.339,3-7.129h1c2.757,0,5-2.243,5-5c0-1.627-0.793-3.061-2-3.974V15   c0-7.72-6.28-14-14-14S29,7.28,29,15v4.026c-1.207,0.914-2,2.348-2,3.974s0.793,3.061,2,3.974V29c0,1.654,1.346,3,3,3h1.841   c0.517,1.179,1.253,2.239,2.159,3.129v2.133l-8.059,2.479C24.985,40.65,23,43.34,23,46.432v1.943c-0.793-1.194-1.802-2.253-3-3.114   V18.739c3.141-2.257,5-5.857,5-9.739c0-2.782-0.979-5.495-2.757-7.639L21.943,1H16v9h-6V1H4.057l-0.3,0.361   C1.979,3.505,1,6.218,1,9c0,3.882,1.859,7.482,5,9.739v26.521C2.859,47.518,1,51.118,1,55c0,2.782,0.979,5.495,2.757,7.639   L4.057,63H10v-9h6v9h5.943l0.3-0.361c0.274-0.33,0.522-0.677,0.757-1.033V63h40V46.432C63,43.34,61.015,40.65,58.059,39.74z    M51.538,39.827l-2.97,6.683l-3.999-2.665l4.712-4.712L51.538,39.827z M41.858,50h2.283l1.693,11h-5.669L41.858,50z M44.465,48   h-2.929l-0.841-1.261L43,45.202l2.305,1.537L44.465,48z M54,26h-1v-6h1c1.654,0,3,1.346,3,3S55.654,26,54,26z M31,15   c0-6.617,5.383-12,12-12s12,5.383,12,12v3.101C54.677,18.035,54.342,18,54,18h-1h-1c-2.957,0-5.737-1.151-7.828-3.242L43,13.586   l-1.172,1.172C39.737,16.849,36.957,18,34,18h-1h-1c-0.342,0-0.677,0.035-1,0.101V15z M32,20h1v6h-1c-1.654,0-3-1.346-3-3   S30.346,20,32,20z M32,30c-0.552,0-1-0.448-1-1v-1.101C31.323,27.965,31.658,28,32,28h1c0,0.685,0.07,1.354,0.202,2H32z M38.184,32   c0.414,1.161,1.514,2,2.816,2h4c1.654,0,3-1.346,3-3s-1.346-3-3-3h-4c-1.302,0-2.402,0.839-2.816,2h-2.921   C35.097,29.359,35,28.692,35,28v-8.037c3.003-0.226,5.803-1.466,8-3.555c2.197,2.089,4.997,3.329,8,3.555V28c0,4.411-3.589,8-8,8   c-2.953,0-5.532-1.613-6.918-4H38.184z M40,31c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1s-0.448,1-1,1h-4   C40.448,32,40,31.552,40,31z M43,38c1.822,0,3.527-0.498,5-1.353v0.939l-5,5l-5-5v-0.939C39.473,37.502,41.178,38,43,38z    M36.719,39.133l4.712,4.712l-3.999,2.665l-2.97-6.683L36.719,39.133z M20.99,61H18v-7c0-1.103-0.897-2-2-2h-6   c-1.103,0-2,0.897-2,2v7H5.01C3.711,59.276,3,57.163,3,55c0-3.387,1.699-6.518,4.547-8.375L8,46.329V17.671l-0.453-0.296   C4.699,15.518,3,12.387,3,9c0-2.163,0.711-4.276,2.01-6H8v7c0,1.103,0.897,2,2,2h6c1.103,0,2-0.897,2-2V3h2.99   C22.289,4.724,23,6.837,23,9c0,3.387-1.699,6.518-4.547,8.375L18,17.671v28.658l0.453,0.296C21.301,48.482,23,51.613,23,55   C23,57.163,22.289,59.276,20.99,61z M25,46.432c0-2.209,1.419-4.13,3.529-4.779l4.007-1.233l4.032,9.071l2.462-1.642l0.922,1.383   L38.142,61H33V49h-2v12h-6V46.432z M61,61h-6V49h-2v12h-5.142l-1.81-11.769l0.922-1.383l2.462,1.642l4.032-9.071l4.007,1.233   c2.11,0.649,3.529,2.57,3.529,4.779V61z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 22,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 22,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 14,
    y: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,18c-1.654,0-3,1.346-3,3v6h2v-6c0-0.552,0.448-1,1-1s1,0.448,1,1v6h2v-6C16,19.346,14.654,18,13,18z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 10,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 10,
    y: 33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,43c0,0.552-0.448,1-1,1s-1-0.448-1-1v-6h-2v6c0,1.654,1.346,3,3,3s3-1.346,3-3v-6h-2V43z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 14,
    y: 33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/serviceIcon.fa170d30eabfdef1758a9a327376c545.svg";
export { ForwardRef as ReactComponent };